import { FormControl } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import {
  BaseNewRequestControlName,
  InvestorDetailsNewRequestFormGroup,
} from '../../../../shared/base-new-request-form/base-new-request-form.model';
import { NgbDateRange } from '../../../../utils/date-helper/date-helper.util';

export enum MIRNewRequestAdditionalControlName {
  ObjectDescription = 'objectDescription',
  FoodCourtStartDate = 'foodCourtStartDate',
  Justification = 'justification',
  DeterminationOfLocation = 'determinationOfLocation',
  WorkScope = 'workScope',
  Project = 'project',
  MonumentInstallationDateRange = 'monumentInstallationDateRange',
}

export const MIRNewRequestControlName = {
  ...BaseNewRequestControlName,
  ...MIRNewRequestAdditionalControlName,
};

export interface MIRNewRequestFormGroup
  extends InvestorDetailsNewRequestFormGroup {
  [MIRNewRequestControlName.ObjectDescription]: FormControl<string>;
  [MIRNewRequestControlName.Justification]: FormControl<string>;
  [MIRNewRequestControlName.FoodCourtStartDate]?: FormControl<NgbDate>;
  [MIRNewRequestControlName.DeterminationOfLocation]?: FormControl<string>;
  [MIRNewRequestControlName.WorkScope]?: FormControl<string>;
  [MIRNewRequestControlName.Project]?: FormControl<string>;
  [MIRNewRequestControlName.MonumentInstallationDateRange]?: FormControl<NgbDateRange>;
}
